import { observer } from "mobx-react";
import React from "react";
import { AppStore } from "../../stores/AppStore";
import { Alignment, Button, Classes, Dialog, FormGroup, H5, InputGroup, Popover, Tag, TextArea } from "@blueprintjs/core";
import { BootstrapTable, TableHeaderColumn, } from "react-bootstrap-table";
import moment from "moment";
import { MDBBtn, MDBCol, MDBRow } from "mdbreact";
import { Pager } from "../utils/Pager";
import { observable } from "mobx";
import { LocatorStore } from "../../stores/admin/LocatorStore";
import { debounce } from "underscore";
import { DefaultSelect, filterItens, renderItens } from "../utils/DefaultSelect";
import { options_java } from "../utils/getStatus";
import { toast } from "react-toastify";

interface Props { }

interface State { }

@observer
export class LocatorsPage extends React.Component<Props, State> {

  obs = observable({
    fetchOptions: {} as any,

    open_create: false as boolean,
    loading_save: false as boolean,
    nome: "" as string,
    locator: "" as string,
    tipo: {} as { cod: string, descricao: string },

    filter: "" as string,
    filter_tipo: { cod: "", descricao: "TODOS" } as { cod: string, descricao: string },

    locators_current: 1
  })

  constructor(props) {
    super(props);

    AppStore.setTitle("Locators");

    this.obs.fetchOptions = debounce(this.handleLocators.bind(this), 800);

  }

  componentDidMount(): void {

    this.obs.locators_current = 1
    this.obs.filter = ""
    this.obs.filter_tipo = { cod: "", descricao: "TODOS" }

    this.handleLocators()

  }

  async handleLocators() {

    await LocatorStore.handleLocators(this.obs.locators_current, this.obs.filter, this.obs.filter_tipo.cod)

  }

  formaterDate = (cell, row) => {

    if (!cell) return ""

    return (
      <span style={{ fontSize: 10 }}>{moment(cell).format("DD/MM/YYYY")}</span>
    )

  };

  formaterTipo = (cell, row) => {

    if (!cell) return ""

    return (
      <span style={{ fontSize: 10 }}>{cell.toUpperCase()}</span>
    )

  };

  formaterLocator = (cell, row) => {

    if (!cell) return ""

    return (
      <span style={{ fontSize: 10 }}>{cell}</span>
    )

  };

  handleBuscaFiltered(filtro: string) {

    this.obs.locators_current = 1
    this.obs.filter = filtro

    this.obs.fetchOptions()

  }

  async handleChangePage(page: number) {

    this.obs.locators_current = page

    await LocatorStore.handleLocators(page, this.obs.filter, this.obs.filter_tipo.cod)

  }

  handleOpenCreate() {

    this.obs.nome = ""
    this.obs.tipo = { cod: "", descricao: "SELECIONE" }
    this.obs.locator = ""

    this.obs.open_create = true

  }

  onClose() {

    this.obs.open_create = false

  }

  async handleSave() {

    if (!this.obs.nome) {
      toast.warn("Favor preencha o campo Nome.", {})
      return
    }

    if (!this.obs.tipo.cod) {
      toast.warn("Favor selecione o campo Tipo.", {})
      return
    }

    if (!this.obs.locator) {
      toast.warn("Favor preencha o campo Locator.", {})
      return
    }

    this.obs.loading_save = true

    const data = {
      nome: this.obs.nome,
      locator: this.obs.locator,
      tipo: this.obs.tipo.cod
    }

    const res = await LocatorStore.handleCreateLocator(data)

    if (res) {

      await LocatorStore.handleLocators(this.obs.locators_current, this.obs.filter, this.obs.filter_tipo.cod)

      this.obs.nome = ""
      // this.obs.tipo = { cod: "", descricao: "SELECIONE" }
      this.obs.locator = ""

    }

    this.obs.loading_save = false

  }

  async handleDeleteLocator(id) {

    const res = await LocatorStore.handleDeleteLocator(id)

    if (res) await LocatorStore.handleLocators(this.obs.locators_current = 1, this.obs.filter, this.obs.filter_tipo.cod)

  }

  handleChangeTipo(e: { cod: string, descricao: string }) {

    this.obs.tipo = e

  }

  async handleFilterTipo(e: { cod: string, descricao: string }) {

    this.obs.filter_tipo = e
    this.obs.locators_current = 1

    await LocatorStore.handleLocators(1, this.obs.filter, this.obs.filter_tipo.cod)

  }

  formaterDetalhes = (cell, row) => {
    return (
      <>
        <Popover popoverClassName={Classes.POPOVER_CONTENT_SIZING}>
          <MDBBtn color="default" rounded size="sm" >
            <img src="/images/bin.png" width="25px" />
          </MDBBtn>
          <div>
            <H5>Confirmar exclusão?</H5>
            <p style={{ fontSize: 11 }}>Tem certeza de que deseja excluir esse item? Você não será capaz de recuperá-lo.</p>
            <div
              style={{
                display: "flex",
                justifyContent: "flex-end",
                marginTop: 15,
              }}
            >
              <Button
                className={Classes.POPOVER_DISMISS}
                style={{ marginRight: 10 }}
              >
                Cancelar
              </Button>
              <Button
                intent="danger"
                className={Classes.POPOVER_DISMISS}
                onClick={() => this.handleDeleteLocator(row._id)}
              >
                Excluir
              </Button>
            </div>
          </div>
        </Popover>
      </>
    )
  }

  onAfterSaveCell = async (row, cellName, cellValue) => {

    if (!row.nome) {
      toast.warn("Campo Nome não pode ficar em branco.", {})
      this.handleLocators()
      return
    }

    if (!row.locator) {
      toast.warn("Campo Locator não pode ficar em branco.", {})
      this.handleLocators()
      return
    }

    const data = {
      id: row._id,
      nome: row.nome,
      locator: row.locator,
      tipo: row.tipo
    }

    await LocatorStore.handleUpdateLocator(data)

    await LocatorStore.handleLocators(this.obs.locators_current, this.obs.filter, this.obs.filter_tipo.cod)

  }

  render() {

    let tipoText = this.obs.tipo.cod ? `${this.obs.tipo.descricao}` : "SELECIONE";

    let tipoAllText = this.obs.filter_tipo.cod ? `${this.obs.filter_tipo.descricao}` : "TODOS";

    const textEdit = {
      type: "input",
    }

    const cellEditProp = {
      mode: 'dbclick',
      blurToSave: true,
      afterSaveCell: this.onAfterSaveCell
    };

    return (

      <>

        <MDBRow style={{ display: "flex", width: "100%", marginBottom: "10px" }}>

          <MDBCol md="3">
            <InputGroup
              round
              leftIcon="search"
              style={{ borderRadius: 10 }}
              placeholder="Filtrar (Nome, Locator)"
              value={this.obs.filter}
              onChange={(e: any) => this.handleBuscaFiltered(e.target.value)}
            />
          </MDBCol>

          <MDBCol md="2">
            <FormGroup className="empresaSelect selectValues">
              <DefaultSelect
                items={[{ cod: "", descricao: "TODOS" }, ...options_java]}
                itemRenderer={renderItens}
                itemPredicate={filterItens}
                onItemSelect={(e) => this.handleFilterTipo(e)}
                matchTargetWidth={true}
                inputProps={{ placeholder: "Filtrar um Tipo" }}
              >
                <Button
                  className="tipo-select-bots"
                  text={tipoAllText}
                  rightIcon="double-caret-vertical"
                  alignText={Alignment.LEFT}
                />
              </DefaultSelect>
            </FormGroup>
          </MDBCol>

          <MDBCol md="2">
            <Button
              text="Criar Locator"
              className="btnDefault btnBuscarNfe btnVerde"
              onClick={() => this.handleOpenCreate()}
            />
          </MDBCol>

        </MDBRow>

        <BootstrapTable className="TabelaSimples" data={LocatorStore.obs.locators} cellEdit={cellEditProp}>
          <TableHeaderColumn dataField="id" width="1%" isKey={true} hidden >#</TableHeaderColumn>
          <TableHeaderColumn dataFormat={this.formaterLocator} dataField="nome" editable={textEdit} width="15%">Nome</TableHeaderColumn>
          <TableHeaderColumn dataFormat={this.formaterTipo} editable={false} dataField="tipo" width="15%">Tipo</TableHeaderColumn>
          <TableHeaderColumn dataFormat={this.formaterLocator} dataField="locator" editable={textEdit} width="80%">Locator</TableHeaderColumn>
          <TableHeaderColumn dataFormat={this.formaterDate} editable={false} dataField="inserted_at" width="15%">Criado em</TableHeaderColumn>
          <TableHeaderColumn dataFormat={this.formaterDetalhes} editable={false} width="10%">Excluir</TableHeaderColumn>
        </BootstrapTable>

        <div style={{ marginTop: 5, float: "right", marginBottom: 120 }}>
          <Pager
            currentPage={this.obs.locators_current}
            totalCount={LocatorStore.obs.locators_length}
            pageSize={15}
            onPageChange={(page) => this.handleChangePage(page)}
          />
        </div>

        <div style={{ marginBottom: 120 }} />

        <Dialog
          isOpen={this.obs.open_create}
          className="AlertUser modalSefa modalAjusteSped"
          onClose={() => this.onClose()}>
          <h2 className="titleSEFAZ modal-sefa">Novo Locator</h2>

          <div style={{ display: "flex" }}>

            <FormGroup className="form-group" label="Nome" labelInfo="*" style={{ width: "50%" }}>
              <InputGroup type="text" onChange={(e) => this.obs.nome = e.target.value} value={this.obs.nome} />
            </FormGroup>

            <FormGroup style={{ width: '50%', marginLeft: 15 }} label="Tipo" labelInfo="*" className="empresaSelect selectValues">
              <DefaultSelect
                items={options_java}
                itemRenderer={renderItens}
                itemPredicate={filterItens}
                onItemSelect={(e) => this.handleChangeTipo(e)}
                matchTargetWidth={true}
                inputProps={{ placeholder: "Filtrar um Tipo" }}
              >
                <Button
                  className="tipo-select-bots"
                  text={tipoText}
                  rightIcon="double-caret-vertical"
                  alignText={Alignment.LEFT}
                />
              </DefaultSelect>
            </FormGroup>
          </div>

          <FormGroup className="form-group" label="Locator" labelInfo="*" style={{ width: "100%" }}>
            <TextArea onChange={(e) => this.obs.locator = e.target.value} value={this.obs.locator} fill />
          </FormGroup>

          <div className={Classes.DIALOG_FOOTER_ACTIONS}>
            <Button text="Cancelar" onClick={() => this.onClose()} />
            <Button text="Salvar" intent="primary" onClick={() => this.handleSave()} disabled={this.obs.loading_save} loading={this.obs.loading_save} />
          </div>

        </Dialog>


      </>

    );

  }

}
